import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { DatePicker } from "antd";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
/**
 * Date Range Filter Component
 * Designed to work with the new filter architecture
 * Handles both single date ranges and separate from/to dates
 */
const DateRangeFilter = ({ name, value, onChange, label, placeholder = ["Дата от", "Дата до"], allowClear = true, style, format = "YYYY-MM-DD", }) => {
    const handleChange = (dates) => {
        if (!dates || !dates[0] || !dates[1]) {
            onChange({ dateFrom: undefined, dateTo: undefined });
            return;
        }
        const dateFrom = dates[0].format(format);
        const dateTo = dates[1].format(format);
        onChange({ dateFrom, dateTo });
    };
    // Convert string dates to dayjs objects for the picker
    const pickerValue = value?.dateFrom && value?.dateTo
        ? [dayjs(value.dateFrom), dayjs(value.dateTo)]
        : null;
    return (_jsxs("div", { children: [label && (_jsxs("label", { style: {
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#595959",
                    marginBottom: "4px",
                    display: "block",
                }, children: [label, ":"] })), _jsx(RangePicker, { style: { width: "100%", ...style }, allowClear: allowClear, placeholder: placeholder, value: pickerValue, onChange: handleChange, "data-filter-name": name, "data-filter-type": "dateRange" })] }));
};
export default DateRangeFilter;
